<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <pulse-loader :loading="loadingCards" :color="$constants.LOADING_COLOR" class="text-center"/>
        <template v-if="cards">
          <div class="alert alert-info">
            <p><strong>Добавление расходов</strong></p>
            <div class="flex align-items-end">
              <div class="form-group mr-2">
                <label for="">Выберите карту</label>
                <select @change="filterRecords" v-model="expenses.selectedCard" class="form-control">
                  <option disabled value="0">Выберите карту</option>
                  <option v-for="card in cards" :value="card.id">{{ printNumber(card.number) }}</option>
                </select>
              </div>
              <div class="form-group mr-2">
                <label for="">Введите сумму</label>
                <input type="number" v-model="expenses.sum" class="form-control">
              </div>
              <div class="form-group mr-2">
                <label for="">Комментарий расхода</label>
                <input type="text" v-model="expenses.comment" class="form-control">
              </div>
              <div class="form-group">
                <LoadingButton
                  title="Создать расход"
                  :loading="loading"
                  :color="$constants.SUCCESS_COLOR"
                  :onClick="() => saveExpenses()"
                  className="btn btn-outline-success"
                />
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
    <div class="card" v-if="records">
      <div class="card-body">
        <pulse-loader :loading="loading" :color="$constants.LOADING_COLOR" class="text-center"/>
        <template v-if="!loading && records">
          <table class="table table-hover table-sm mt-1">
            <thead>
            <tr>
              <th></th>
              <th></th>
              <th></th>
              <th>Дата отчета</th>
              <th>Комментарий</th>
              <th>Сумма</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(r, i) in records" :key="i">
              <td>{{ i + 1 }}</td>
              <td>
                <i v-bind:class="{
                  'icon-fa': true,
                  'icon-fa-arrow-up red': r.action !== 'income',
                  'icon-fa-arrow-down green': r.action === 'income',
                }"></i>
              </td>
              <td>
                <template v-if="r.type === 'expenses'">
                  расход
                </template>
                <template v-if="r.type === 'order'">
                  <button
                    @click="orderToEdit(r.id)"
                    class="btn btn-xs btn-info mr-1"
                  >
                    <i class="icon-fa icon-fa-eye"/>
                  </button>
                  {{ r.id }}
                </template>
              </td>
              <td>{{ printDate(r.date) }}</td>
              <td>{{ r.comment }}</td>
              <td>{{ r.sum.toLocaleString('ru-RU') }}</td>
            </tr>
            <tr>
              <td colspan="5"></td>
              <td><strong>{{ totalSum.grand.toLocaleString('ru-RU') }}</strong></td>
            </tr>
            </tbody>
          </table>
        </template>
      </div>
    </div>
  </div>
</template>

<script>

import api from "@/api";
import moment from "moment";
import LoadingButton from "@/components/buttons/LoadingButton";

export default {
  components: {LoadingButton},
  data() {
    return {
      loadingCards: false,
      loading: false,
      selectedCard: 0,
      expenses: {
        selectedCard: 0,
        sum: null,
        comment: null,
      },
      totalSum: {
        grand: 0
      },
      cashouts: null,
      cards: null,
      records: null,
    }
  },
  created() {
    this.getRecords();
  },
  methods: {
    async saveExpenses() {
      if (!this.expenses.selectedCard) {
        toastr['warning']('Выберите карту для расхода!')
        return;
      }
      if (!this.expenses.sum || this.expenses.sum <= 0) {
        toastr['warning']('Укажите сумму для расхода!')
        return;
      }
      if (!this.expenses.comment) {
        toastr['warning']('Укажите комментарий для расхода!')
        return;
      }
      this.loading = true;
      const {data} = await api.post('/reports/updateExpenses', {
        date: moment().format('YYYY-MM-DD'),
        userId: 0,
        expenses: [{
          division_id: 0,
          to_division_id: 0,
          type_id: 27, // pre paid cards
          sum: this.expenses.sum,
          comment: this.expenses.comment,
          card_id: this.expenses.selectedCard,
          currency_id: 33
        }]
      })
      if (data.success) {
        toastr['success']('Сохранено!')
        this.expenses = {
          selectedCard: 0,
          sum: null,
          comment: null,
        };
        this.getRecords();
      } else {
        toastr['warning'](data.message, 'Ошибка!')
      }
      this.loading = false;
    },
    filterRecords() {

    },
    orderToEdit(id, dialog = null) {
      // this.$store.dispatch('orders/setOrderToEdit', {orderId: id, dialog: {...dialog, messages: this.activeMessages}});
      this.$store.dispatch('orders/setOrderToEdit', {orderId: id});
    },
    async getRecords() {
      this.loadingCards = true;
      const {data} = await api.post('/cards/report', {
        cards_type: 2
      });
      if (data.success) {
        this.cards = data.cards;
        let sum = 0;
        const orders = data.orders.reduce((acc, o) => {
          acc.push({
            type: 'order',
            action: 'income',
            id: o.id,
            date: o.report_date || o.created_at,
            sortField: moment(o.report_date || o.created_at).unix(),
            sum: o.no_cash_price,
            comment: o.extra_options.pre_paid_comment || null
          })
          sum += o.no_cash_price;
          return acc;
        }, []);
        const expenses = data.expenses.reduce((acc, e) => {
          acc.push({
            type: 'expenses',
            action: 'outcome',
            id: e.id,
            date: e.pass_date,
            sortField: moment(e.pass_date).unix(),
            sum: e.sum,
            comment: e.comment
          });
          sum -= e.sum;
          return acc;
        }, []);
        const cashouts = data.cashouts.reduce((acc, c) => {
          acc.push({
            type: 'cashout',
            action: 'outcome',
            id: c.id,
            date: c.created_at,
            sortField: moment(c.created_at).unix(),
            sum: c.sum,
            comment: 'обналичка'
          });
          sum -= c.sum;
          return acc;
        }, [])
        this.totalSum.grand = sum;
        this.records = _.orderBy([...orders, ...expenses, ...cashouts], 'sortField');
      } else {
        toastr['warning'](data.message, 'Ошибка!')
      }
      this.loadingCards = false;
    },
    printNumber(num) {
      return num.substr(0, 4) + ' ' + num.substr(4, 4) + ' ' + num.substr(8, 4) + ' ' + num.substr(12);
    },
    async getCards() {
      this.loadingCards = true;
      const {data} = await api.index('/cards/getCards?type=2');
      if (data.success) {
        this.cards = data.records;
      } else {
        toastr['warning'](data.message, 'Ошибка!')
      }
      this.loadingCards = false;
    }
  }
}

</script>

<style scoped>
table.table td {
  padding: 3px;
}

.icon-fa.red {
  color: red;
}

.icon-fa.green {
  color: green;
}
</style>
